import React from 'react';

import ErrorBoundary from 'components/Common/ErrorBoundary';
import { useCanOpenStudio } from 'contextProviders/SplashScreenProviders/UserAndAccountProviders/UIVersionProvider';
import NotFoundPage from 'screens/NotFoundPage';

// Studio's routes, where the account has Studio (see useCanOpenStudio).
// Elsewhere its URLs are Not Found, which sends the user home. A failure in
// Studio (or loading it) stays in Studio, leaving the app's nav working.
const StudioRouteGate = ({ children }: { children: JSX.Element }) => {
  const canOpenStudio = useCanOpenStudio();

  if (!canOpenStudio) {
    return <NotFoundPage />;
  }

  return <ErrorBoundary isRetryable>{children}</ErrorBoundary>;
};

export default StudioRouteGate;
